"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
const hooks_1 = require("../../../hooks");
const react_loops_1 = require("react-loops");
const lodash_1 = require("lodash");
const ContentKeyListItem_1 = require("./ContentKeyListItem");
exports.EmailCanvasBlockContentKeyModal = ({ toggle, isOpen }) => {
    const { updateBlock } = hooks_1.useEmailCanvasBlockDetailChangeContext();
    const { block: { contentItem, contentFieldKey }, } = hooks_1.useEmailCanvasBlockDetailContext();
    const sortedContentItemFields = react_1.useMemo(() => {
        if (!contentItem) {
            return [];
        }
        return lodash_1.sortBy(Object.entries(contentItem), ['id']).map(res => {
            return res[1];
        });
    }, [contentItem]);
    return (react_1.default.createElement(react_2.OsmosysModal, { centered: true, isOpen: isOpen, toggle: () => toggle(false) },
        react_1.default.createElement(react_2.OsmosysModal.Header, { toggle: () => toggle(false) }, "Content source"),
        react_1.default.createElement(react_2.OsmosysModal.Body, null,
            react_1.default.createElement(react_loops_1.For, { of: sortedContentItemFields }, (contentField, meta) => {
                return (react_1.default.createElement(ContentKeyListItem_1.EmailCanvasBlockContentKeyListItem, Object.assign({ contentField: contentField }, meta, { isActive: contentField.id === contentFieldKey, onSelect: () => {
                        updateBlock({
                            contentFieldKey: contentField.id,
                        });
                        toggle(false);
                    } })));
            }))));
};
//# sourceMappingURL=index.js.map